export default __webpack_public_path__ + "static/media/600px-Headshot.62e40977.jpg";